import React from 'react'
import { MenuItemType } from '@utils/types'
import { DownloadLink, EditableTitle } from '@components/atoms'
import styles from './CataloghiBlock.module.sass'

interface Props {
  item: MenuItemType
  editMode?: boolean
  className?: string
}

const CataloghiBlock = (props: Props) => {
  const { item = undefined, editMode = false, className = '' } = props

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <EditableTitle title={item.name} variant="h3" className={styles.title} editMode={editMode} />
      {editMode ? (
        <>{item.children}</>
      ) : item.children?.length ? (
        <div className={`${styles.list}`}>
          {item.children?.map((x) => (
            <DownloadLink key={x.pk} item={x} />
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  ) : (
    <></>
  )
}

export default CataloghiBlock
